module.exports = __webpack_public_path__ + "img/example-xls.27da53b9.svg";